import { Coordinates } from 'models';

import { SheetModel } from './sheet-model';

export interface MapMarker {
  position: Coordinates;
  label?: string;
  icon: MarkerIcon;
  sheet?: SheetModel;
}

export enum MarkerIcon {
  AIRPORT = 'AIRPORT',
  CIRCLE = 'CIRCLE',
  HOTEL = 'HOTEL',
  LANDMARK = 'LANDMARK',
  METRO = 'METRO',
  RESTAURANT = 'RESTAURANT',
  SOLD_OUT = 'SOLD_OUT',
  TRAIN = 'TRAIN'
}
